import React, { ReactElement, useState } from "react";
import {
    CrossSellM2Context,
    CrossSellM2SuggestionsState,
    INITIAL_CROSS_SELL_M2_SUGGESSTIONS_VALUE,
} from "@cart-client/contexts/CrossSellM2Context";

export function CrossSellM2ContextProvider(props: { children: React.ReactNode }): ReactElement {
    const [crossSellM2SuggestionsState, setCrossSellM2SuggestionsState] = useState<CrossSellM2SuggestionsState>(
        INITIAL_CROSS_SELL_M2_SUGGESSTIONS_VALUE.crossSellM2SuggestionsState,
    );

    const crossSellM2ContextValue = React.useMemo(
        () => ({
            crossSellM2SuggestionsState,
            setCrossSellM2SuggestionsState,
        }),
        [crossSellM2SuggestionsState],
    );

    return <CrossSellM2Context.Provider value={crossSellM2ContextValue}>{props.children}</CrossSellM2Context.Provider>;
}
